import React from 'react';
import AppBaseComponent from '../../../components/AppBaseComponent';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { connect } from 'react-redux';
import moment from 'moment';
import DatePicker from "react-datepicker";
import Loader from "../../../components/ui/Loader/Loader";
import tapIcon from "../../../services/TapIcon";
import Ax from "../../../components/hoc/Ax";
import Status from '../../../components/ui/Status';
import TapSelect from '../../../components/ui/TapSelect';
import HttpAPICall from '../../../services/HttpAPICall';
import { IAM_API_BASE_URL_2, INVENTORY_API_BASE_URL_2, ISC_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import WarehouseAddress from '../includes/WarehouseAddress';
import AssetMiniDetail from '../../includes/AssetMiniDetail';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import InputItemSearch from '../../includes/ui/InputItemSearch';
import AddItemModal from '../../items/itemsAdd/AddItemModal';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';
import ItemDetailsModal from '../../items/itemDetails/ItemDetailsModal';
import ItemEditModal from '../../items/itemsAdd/ItemEditModal';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import InputEmployeeSearch from '../../includes/ui/InputEmployeeSearch';
import ItemSearchModal from '../../items/itemSearchModal';
import InputTicketSearch from '../../includes/ui/InputTicketSearch';
import InputSubAssemblySearch from '../../includes/ui/InputSubAssemblySearch';
import TapInputNumber from '../../../components/ui/TapInputNumber';
import InputWorkstationSearch from '../../includes/ui/InputWorkstationSearch';
import GeneralSelectFor from '../../includes/GeneralSelectFor';

class AllocationAdd extends AppBaseComponent {
    
    constructor(props) {
        super(props);
        
        this.initAllocationForm        =   {
            transaction_date                :   new Date(),
            warehouse_id                    :   '',
            allocation_for                  :   'asset',
            workstation_id                  :   '',
            asset_id                        :   '',
            sub_assembly_id                 :   '',
            voucher_number                  :   '',
            voucher_date                    :   '',
            items                           :   [],
            notes                           :   '',
            adjustment_amount               :   0,
            ticket_id                       :   '',
            employee_id                     :   '',
            vendor_id                       :   '', 
            customer_id                     :   ''
        }
        
        this.initAllocationItemRows   =   [{
            item                            :   null,
            stock_id                        :   null,
            remark                          :   '',
            amount                          :   0,
            qty                             :   0,
            stock_qty                       :   0,
            free_qty                        :   0,
            rate                            :   0,
            current_stocks                  :   [],
            selected_stock                  :   null,
            stock_loading                   :   false,
            allApiCallsCompleted            :   false,
        }];
        
        this.initalState                =   {
            allocationFormDataLoaded        :   false,
            allWarehouses                   :   [],
            allGstSlabs                     :   [],
            allStatus                       :   [],
            isc_configuration               :   null,
            track_batch_expiry              :   'N',
            negative_stock                  :   'N',
            allocationForm                  :   this.initAllocationForm,
            saveFormSubmitting              :   false,
            allocationDetail                :   null,
            selectedSite                    :   null,
            warehouseDetailLoading          :   false,
            warehouseDetail                 :   null,
            warehouseSites                  :   [],
            selectedAsset                   :   null,
            allocationItemRows              :   [...this.initAllocationItemRows] ,
            itemRowNumber                   :   0  ,
            cloneallocation                 :   false,
            consumtionHistoryList           :   [],
            allocationDetailLoading         :   false,
            only_stocked_item               :   'Y',
            searchedEmployee                :   null,
            selectedTicket                  :   null,
            ticketSelectedSite              :   '',
            ticketSelectedAsset             :   '',
            ticketFromAllocation            :   false,
            ticket_allocation               :   'N',
            buttonDisabled                  :   false,
            searchSubassembly               :   null,
            ticketFromTicket                :   false,
            allAllocationsFor               :   [],
            allDemandListing                :   [],
            allSelectedDemandList           :   [],
            allItemWiseDemandListing        :   [],
            demand_listing_loading          :   false,          
            searchedWorkstation             :   null,
            itemDemandLoaded                :   false,
            showItemSearchModal             :   false,
            showItemAddModal                :   false,
            showItemEditModal               :   false,
            isc_prevent_back_day_voucher    :   false,

            form_loading                    :   false,
            forData                         :   {
                type                            :   "Allocation For",
                isRequired                      :   true,
                forField                        :   ['asset', 'workstation', 'employee', 'sub_assembly', 'vendor', 'customer'],   
                warehouseSites                  :   [],
                chageWarehouse                  :   false,
                ticketSelected                  :   false,
                editData                        :   {
                    type                        :   '',
                    selected_asset              :   null,
                    selected_workstation        :   null,
                    selected_employee           :   null,
                    selected_subassembly        :   null,
                    selected_customer           :   null,
                    selected_vendor             :   null,
                    workstation_id              :   '',
                    asset_id                    :   '',
                    employee_id                 :   '',
                    sub_assembly_id             :   '',
                    customer_id                 :   '',
                    vendor_id                   :   '',
                }
            }
        }
        
        this.state                      =   {
            ...this.initalState
        };
        this.addItemModalRef            =   React.createRef();
        this.editItemModalRef           =   React.createRef();
        this.allocationHistoryRef       =   React.createRef();
        this.itemDetailsRef             =   React.createRef();
        this.itemSearchRef              =   React.createRef();

        this.formDataUrl                =   INVENTORY_API_BASE_URL_2 + '/allocation/add_form_data';
        this.allocationUrl              =   INVENTORY_API_BASE_URL_2 + '/allocation';
        this.fetchDemandUrl             =   INVENTORY_API_BASE_URL_2  + '/item_demand/list';
        this.itemCurrentStockUrl        =   INVENTORY_API_BASE_URL_2 + '/item_current_stock';
        this.itemDetailUrl              =   INVENTORY_API_BASE_URL_2 + '/item'
        this.warehouseUrl               =   ISC_API_BASE_URL_2  +   '/warehouse';
        this.ticketDetailUrl            =   IAM_API_BASE_URL_2 + "/ticket/detail";
        this.reportUrl                  =   INVENTORY_API_BASE_URL_2 + '/item_demand/report/item-wise';
         this.itemsUrl             =   INVENTORY_API_BASE_URL_2 + '/items'
        // this.allocationFor              =   [
        //     {label: 'Asset', value: 'asset'},
        //     {label: 'Workstation', value: 'workstation'},
        //     {label: 'Employee', value: 'employee'},
        //     {label: 'Sub Assembly', value: 'sub_assembly'},
        // ];
    }
    
    componentDidMount() {
        window.addEventListener('keydown', this.handleScannerKeyDown);
        this.pickItemModal                           =   new Modal(document.getElementById('pickItemModal'), {keyboard: false, backdrop :false});
        this.pickItemDemandModal                     =   new Modal(document.getElementById('pickItemDemandModal'), {keyboard: false, backdrop :false});
        this.initilaizeFormData(this.props);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleScannerKeyDown);
        if (this.scannerKeyTimer) clearTimeout(this.scannerKeyTimer);
    }

    handleScannerKeyDown = (event) => {
        const key = event.key;
        if (key === 'Enter') {
            const scannedValue = (this.scannerBuffer || '').trim();
            if (scannedValue) {
                this.handleScannedValue(scannedValue);
                this.scannerBuffer = '';
            }
            return;
        }
        if (key && key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
            this.scannerBuffer = (this.scannerBuffer || '') + key;
        }
        clearTimeout(this.scannerKeyTimer);
        this.scannerKeyTimer = setTimeout(() => { this.scannerBuffer = ''; }, 120);
    }

    normalizeScannerValue = (value) => {
        if (value === null || value === undefined) return '';
        return String(value).trim().replace(/^"|"$/g, '').replace(/T.*$/, '');
    };

    handleScannedValue = (scannedValue) => {
        let payload = scannedValue;
        let itemCode = '';
        try {
            const parsed = JSON.parse(scannedValue);
            if (parsed && (parsed.i || parsed.item_code || parsed.code)) {
                payload = parsed;
                itemCode = parsed.i || parsed.item_code || parsed.code;
            }
        } catch (error) {
            const rawMatch = scannedValue.match(/"i"\s*:\s*"([^"]+)"|item_code\s*[:=]\s*([A-Za-z0-9\-_.]+)/i);
            if (rawMatch) itemCode = rawMatch[1] || rawMatch[2];
        }
        if (!itemCode) itemCode = typeof payload === 'string' ? payload : '';
        const finalItemCode = String(itemCode || '').trim();
        if (!finalItemCode) return;

        const warehouseId = this.state.allocationForm.warehouse_id;
        if (!warehouseId) {
            toast.error('Please select Warehouse before scanning an item', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        HttpAPICall.withAthorization('GET', this.itemDetailUrl, this.props.access_token, {
            search_by_text: finalItemCode, page: 1, per_page: 10
        }, {}, (itemResponse) => {
            const itemData = itemResponse?.data?.data?.[0];
            if (!itemData) {
                toast.error('No item found for scanned code: ' + finalItemCode, { position: toast.POSITION.TOP_RIGHT });
                return;
            }
            if (itemData.category === 'services') {
                this.upsertScannedAllocationRow(itemData, payload);
                return;
            }

            HttpAPICall.withAthorization('GET', this.itemCurrentStockUrl + '/' + itemData.id, this.props.access_token, {
                interchangeable_items_current_stock: 'N', warehouse_id: warehouseId
            }, {}, (stockResponse) => {
                const stockList = Array.isArray(stockResponse?.data?.current_stock) ? stockResponse.data.current_stock : [];
                const currentStocks = stockList.map((stock) => ({
                    value: stock.qty,
                    label: (<Ax>Batch Number: <b>{stock.batch_number}</b><br />Expiry Date: <b>{stock.expiry_date_display}</b><br />Free Stock: <b>{stock.free_qty}</b></Ax>),
                    stock, batch_number: stock.batch_number || null, expiry_date: stock.expiry_date || null,
                    expiry_date_display: stock.expiry_date_display || null, stock_qty: stock.qty,
                    free_qty: stock.free_qty, display_label: `${stock.batch_number} & ${stock.expiry_date_display}`
                }));
                const scannedBatch = this.normalizeScannerValue(payload?.b || payload?.batch_number || payload?.batch);
                const scannedExpiry = this.normalizeScannerValue(payload?.e || payload?.expiry_date || payload?.expiry || payload?.expiryDate);
                const matchedStock = currentStocks.find((stock) =>
                    this.normalizeScannerValue(stock.batch_number || stock.stock?.batch_number) === scannedBatch &&
                    this.normalizeScannerValue(stock.expiry_date || stock.expiry_date_display || stock.stock?.expiry_date) === scannedExpiry
                ) || (!scannedBatch && !scannedExpiry && currentStocks.length === 1 ? currentStocks[0] : null);
                if ((scannedBatch || scannedExpiry) && !matchedStock) {
                    toast.error('Scanned batch is not available in the selected warehouse', { position: toast.POSITION.TOP_RIGHT });
                    return;
                }
                this.upsertScannedAllocationRow(itemData, payload, {
                    current_stocks: currentStocks, selected_stock: matchedStock?.stock || null
                });
            }, () => this.upsertScannedAllocationRow(itemData, payload));
        }, () => toast.error('Unable to fetch item for scanned code', { position: toast.POSITION.TOP_RIGHT }));
    }

    upsertScannedAllocationRow = (itemData, scannedMeta = {}, stockData = {}) => {
        const rows = [...this.state.allocationItemRows];
        const scannedBatch = this.normalizeScannerValue(scannedMeta?.b || scannedMeta?.batch_number || scannedMeta?.batch);
        const scannedExpiry = this.normalizeScannerValue(scannedMeta?.e || scannedMeta?.expiry_date || scannedMeta?.expiry || scannedMeta?.expiryDate);
        const currentStocks = Array.isArray(stockData.current_stocks) ? stockData.current_stocks : [];
        const selectedStock = stockData.selected_stock || currentStocks.find((stock) =>
            this.normalizeScannerValue(stock.batch_number || stock.stock?.batch_number) === scannedBatch &&
            this.normalizeScannerValue(stock.expiry_date || stock.expiry_date_display || stock.stock?.expiry_date) === scannedExpiry
        )?.stock || null;
        const matchedBatch = scannedBatch || this.normalizeScannerValue(selectedStock?.batch_number);
        const matchedExpiry = scannedExpiry || this.normalizeScannerValue(selectedStock?.expiry_date || selectedStock?.expiry_date_display);
        let targetIndex = rows.findIndex((row) => row.item?.id === itemData.id &&
            this.normalizeScannerValue(row.selected_stock?.batch_number || row.batch_number) === matchedBatch &&
            this.normalizeScannerValue(row.selected_stock?.expiry_date || row.selected_stock?.expiry_date_display || row.expiry_date) === matchedExpiry
        );
        const isExistingRow = targetIndex !== -1;
        if (targetIndex === -1) {
            targetIndex = rows.findIndex((row) => !row.item);
            if (targetIndex === -1) {
                rows.push({ ...this.initAllocationItemRows[0] });
                targetIndex = rows.length - 1;
            }
        }
        const existingRow = rows[targetIndex] || {};
        const rowStock = selectedStock || existingRow.selected_stock || null;
        rows[targetIndex] = {
            ...existingRow, item: itemData, qty: Number(existingRow.qty || 0) + 1,
            rate: existingRow.rate || itemData.consumption_price || 0, current_stocks: currentStocks,
            selected_stock: rowStock, stock_qty: Number(rowStock?.qty ?? rowStock?.total_qty ?? 0),
            free_qty: Number(rowStock?.free_qty ?? 0), batch_number: matchedBatch, expiry_date: matchedExpiry,
            stock_loading: false, allApiCallsCompleted: true
        };
        this.setState({ allocationItemRows: rows }, () => {
            if (!isExistingRow && !this.state.allocationItemRows.find((row) => !row.item)) this.addNewItemRow();
            this.handleButtonEnable();
        });
    }

    componentWillReceiveProps(nextProps){
        if(this.props.location && this.props.location.state){
            if(nextProps.location.state !== this.props.location.state) {
                this.initilaizeFormData(nextProps)
             }  
        }        
    }

    forDataForEditClone = (allocationDetail) => {        
        const {workstation, employee, subAssembly, assetProfile, customer, vendor, allocation_for} =   allocationDetail                                 
        return {
            allocation_for,
            workstation_id              :   workstation ? workstation.id : '',
            selected_workstation        :   workstation ? {label: workstation.workstation_name, value : workstation.id} : null,
            employee_id                 :   employee ? employee.enc_id : '',
            selected_employee           :   employee ? {label: employee.display_full_name, value : employee.enc_id} : null,
            sub_assembly_id             :   subAssembly ? subAssembly.enc_id : '',
            selected_subassembly        :   subAssembly ? {label: subAssembly.name, value : subAssembly.enc_id} : null,
            asset_id                    :   assetProfile ? assetProfile.asset_id : '',
            selected_asset              :   assetProfile ? {label: `${assetProfile.name} (${assetProfile.asset_code})`, value : assetProfile.asset_id, ...assetProfile} : null,

            customer_id                 :   customer ? customer.id : '',
            selected_customer           :   customer ? {label: customer.name, value: customer.id} : '',
            vendor_id                   :   vendor ? vendor.id : '',
            selected_vendor             :   vendor ? {label: vendor.name, value: vendor.id} : '',
        }
    }

    demandForData = (demandDetail) => {        
        const {workstation, employee, sub_assembly, asset, customer, vendor, demand_for} =   demandDetail                                 
        return {
            allocation_for              :   demand_for,
            workstation_id              :   workstation ? workstation.id : '',
            selected_workstation        :   workstation ? {label: workstation.workstation_name, value : workstation.id} : null,
            employee_id                 :   employee ? employee.enc_id : '',
            selected_employee           :   employee ? {label: employee.display_full_name, value : employee.enc_id} : null,
            sub_assembly_id             :   sub_assembly ? sub_assembly.enc_id : '',
            selected_subassembly        :   sub_assembly ? {label: sub_assembly.name, value : sub_assembly.enc_id} : null,
            asset_id                    :   asset ? asset.asset_id : '',
            selected_asset              :   asset ? {label: `${asset.name} (${asset.asset_code})`, value : asset.asset_id, ...asset} : null,

            customer_id                 :   customer ? customer.id : '',
            selected_customer           :   customer ? {label: customer.name, value: customer.id} : '',
            vendor_id                   :   vendor ? vendor.id : '',
            selected_vendor             :   vendor ? {label: vendor.name, value: vendor.id} : '',
        }
    }

    ticketForData   =   (ticketForData, ticketFor) => {
        return {
            asset_id            :   ticketForData && ticketFor === 'asset' && ticketForData ? ticketForData.asset_id : "",
            selected_asset      :   ticketFor === 'asset' && ticketForData  ? { ...ticketForData, label: `${ticketForData?.name} (${ticketForData?.asset_code})` } : null,

            workstation_id      :   ticketForData && ticketFor === 'workstation' && ticketForData ? ticketForData.id : "",

            selected_workstation    :   ticketFor === "workstation" && ticketForData ? {value:ticketForData.id,label:ticketForData.name } : null,

            employee_id         :   ticketForData && ticketFor === 'employee' && ticketForData  ? ticketForData.enc_id : "",

            selected_employee   :   ticketFor === 'employee' && ticketForData ? {
                                        value : ticketForData.enc_id, label : ticketForData.display_full_name, employee : ticketForData
                                    } : null, 

            
            sub_assembly_id      :  ticketForData && ticketFor === 'sub_assembly' && ticketForData  ? ticketForData.enc_id : "",

            selected_subassembly :   ticketFor === 'sub_assembly' && ticketForData  ? {
                                        label                   :   ticketForData.name,
                                        value                   :   ticketForData.enc_id,
                                        display_label           :   ticketForData.name,
                                    } : null,
        }


    }


    // buttonDisabled
    initilaizeFormData                  =   (pr)  =>  {
        let sites                       =   pr.iam_group_sites;

        this.setState({form_loading : true});
            HttpAPICall.withAthorization('GET', this.formDataUrl , this.props.access_token, null, null, (response) => {
                let formData = response.data
                this.setState({
                    allocationFormDataLoaded   :   formData ? true : false,
                    ticket_allocation          :   formData && formData.setting && formData.setting.ticket_allocation ? formData.setting.ticket_allocation : 'N',
                    allWarehouses               :   pr.all_warehouses && pr.all_warehouses.length > 0 ? pr.all_warehouses.map((s) => { return {value: s.id, label: `${s.name} (${s.code})` , site_id : s.site_ids}; }) : [],
                    allAllocationsFor            :   [{value:'asset',label:'Asset'},{value:'workstation',label:'Workstation'},{value:'employee',label:'Employee'},{value:'sub_assembly',label:'Sub Assembly'}],
                    allStatus                   :   formData && formData.status && formData.status.length > 0 ? formData.status.map((s) => { return {value: s.id, label: s.name}; }) : [],
                    track_batch_expiry          :   pr.isc_configuration && pr.isc_configuration.track_batch_expiry ? pr.isc_configuration.track_batch_expiry : 'N',
                    negative_stock              :   pr.isc_configuration && pr.isc_configuration.negative_stock ? pr.isc_configuration.negative_stock : 'N',
                    only_stocked_item           :    pr.isc_configuration && pr.isc_configuration.negative_stock && pr.isc_configuration.negative_stock == 'N' ? 'Y' : 'N',
                    isc_prevent_back_day_voucher           :    pr.isc_setting && pr.isc_setting.isc_prevent_back_day_voucher && pr.isc_setting.isc_prevent_back_day_voucher ? pr.isc_setting.isc_prevent_back_day_voucher : 'N',
                }, () => {
                    
                    let ParamObject                 =       new URLSearchParams(this.props.location.search);
                    if(pr.location && pr.location.state && pr.location.state.allocationData) {
                      
                        let allocationDetail       =   pr.location.state.allocationData;
                        let allocationItems        =   allocationDetail.items;

                        const {allocation_for, workstation_id, selected_workstation, employee_id, selected_employee, sub_assembly_id, selected_subassembly, asset_id, selected_asset, customer_id, selected_customer, vendor_id, selected_vendor}    =   this.forDataForEditClone(allocationDetail)
                       // console.log(allocationDetail.ticket,'hhh')
                        this.setState({
                            allocationDetail                :   pr.location && pr.location.state && pr.location.state.clone ? null : allocationDetail,
                            allocationForm                  :   {
                                ...this.initAllocationForm,
                                transaction_date            :   pr.location && pr.location.state && pr.location.state.clone ?  moment(new Date(),'YYYY-MM-DD').format('YYYY-MM-DD') : allocationDetail.transaction_date,
                                warehouse_id                :   allocationDetail.warehouse_id,
                                voucher_number              :   allocationDetail.voucher_number,
                                voucher_date                :   allocationDetail.voucher_date ? allocationDetail.voucher_date : '',
                                notes                       :   allocationDetail.notes,
                                adjustment_amount           :   allocationDetail.adjustment_amount,
                                status                      :   allocationDetail.status,
                                demand_transaction_id       :   allocationDetail.demand_transaction_id,
                                ticket_id                   :   allocationDetail.ticket ? allocationDetail.ticket.activity_id : '',

                                allocation_for,
                                asset_id,
                                workstation_id,
                                employee_id,
                                sub_assembly_id,
                                customer_id,
                                vendor_id,
                            },

                            forData                         :   {
                                ...this.state.forData, 
                                 ticketSelected :  ((allocationDetail.ticket) ||allocationDetail.demand_transaction_id  ) ? true : false,
                                editData : {
                                    ...this.state.forData.editData,
                                    // chageWarehouse : !this.state.forData.chageWarehouse,
                                    type           :   allocation_for, 
                                    workstation_id, selected_workstation,
                                    employee_id, selected_employee,
                                    asset_id, selected_asset,
                                    sub_assembly_id, selected_subassembly,
                                    customer_id, selected_customer, 
                                    vendor_id, selected_vendor
                                }
                            },

                            buttonDisabled                  :  true,
                            ticketFromAllocation            :   allocationDetail.ticket ? true : false,
                            
                            ticketSelectedAsset             :   allocationDetail.ticket && allocationDetail.allocation_for == "asset" && allocationDetail.assetProfile ? allocationDetail.assetProfile : null,
                            selectedTicket                  :   allocationDetail.ticket ? {...allocationDetail.ticket, value: allocationDetail.ticket.activity_id, label: `${allocationDetail.ticket.activity_id} : ${allocationDetail.ticket.header}`, display_label: `${allocationDetail.ticket.activity_id} : ${allocationDetail.ticket.header}` } : null,
                            allStatus                       :   allocationDetail && allocationDetail.user_status && allocationDetail.user_status.length > 0 ? allocationDetail.user_status.map((s) => { return {value: s.id, label: s.name}; }) : [],
                        }, () => {
                            if(allocationDetail.demand_transaction_id){
                                this.fetchAllDemandListing(allocationDetail.demand_transaction_id)
                            }
                            this.getWarehouseDetail(allocationDetail.warehouse_id, true);
                            let assetProfile        =   allocationDetail.assetProfile;
                            if(assetProfile) {
                                this.setState({selectedAsset : {...assetProfile, label : `${assetProfile.name} (${assetProfile.asset_code})` }});
                            }

                            let employeeProfile        =   allocationDetail.employee;
                            if(employeeProfile) {
                                this.setState({searchedEmployee : {value : employeeProfile.enc_id, label : `${employeeProfile.display_full_name}`,employee : employeeProfile }});
                            }

                            let workstation        =   allocationDetail.workstation;
                            if(workstation) {
                                this.setState({searchedWorkstation : {value:workstation.id,label:workstation.workstation_name }});
                            }
                            let subAssembly         =   allocationDetail.subAssembly;
                            if(subAssembly) {
                                this.setState({
                                    searchSubassembly : {
                                        label               :   subAssembly.name,
                                        value               :   subAssembly.enc_id,
                                        display_label       :   subAssembly.name,
                                        subAssembly         :   subAssembly
                                    }
                                })
                            }
                            const allocationItems = this.props.location.state.allocationData.items || [];

                            this.setState({
                                allocationItemRows: allocationItems.map(item => ({
                                    item:{... item.itemData,isAddRemark : item.remark ? true : false},
                                    qty: item.pending_qty || item.qty,
                                    rate: item.rate,
                                    
                                    remark: item.remark || '',
                                    allocation_item_id: item.id,
                                    pending_qty: item.pending_qty || 0,
                                    item_current_qty: item.qty || 0,
                                    demand_pending_qty: item.pending_qty || 0,
                                    demand_item_id: item.demand_item_id || '',
                                    demand_transaction_id: item.demand_transaction_id || '',
                                    stock_loading: true,
                                    allApiCallsCompleted: false
                                }))
                            }, () => {

                                // 🔥 Call API ONCE for all items
                                this.fetchItemsForAllocation(
                                    allocationItems,
                                    this.state.allocationForm.warehouse_id,
                                    { mode: 'edit' }
                                );

                            });


                            
                           
                        });
                    }

                    if(pr.location && pr.location.state && pr.location.state.addAllocationFromPurchase) {
                      
                        let allocationDetail       =   pr.location.state.addAllocationFromPurchase;
                       
                        let allocationItems           =   allocationDetail.items;
                          
                        setTimeout(() => {
                            this.setState({
                                allocationDetail    :   null,
                                buttonDisabled      :  true,
                                allocationForm      :   {
                                    ...this.initAllocationForm,
                                    transaction_date        :    moment(new Date(),'YYYY-MM-DD').format('YYYY-MM-DD') ,
                                    warehouse_id            :   allocationDetail.warehouse_id,
                                }
                            }, () => {
                                this.getWarehouseDetail(allocationDetail.warehouse_id, true);
                                
                                this.setState({
                                allocationItemRows: allocationItems.map(item => ({
                                    ...item,
                                    item: item.item,
                                    qty: item.qty,
                                    rate: item.rate,
                                    remark: item.remark || '',
                                    stock_loading: true,
                                    allApiCallsCompleted: false,
                                    isAddRemark : item?.remark ? true : false
                                }))
                            }, () => {

                                // 🔥 Call API ONCE for all items
                                this.fetchItemsForAllocation(
                                    allocationItems,
                                    this.state.allocationForm.warehouse_id,
                                    { mode: 'edit' }
                                );

                            });
                                

                            });
                        },500)
                       
                    }

                    if (pr.location && pr.location.state && pr.location.state.addAllocationFromInventoryTransfer) {
                        let allocationDetail = pr.location.state.addAllocationFromInventoryTransfer;
                        let consumedItems = allocationDetail.items;
                        
                        setTimeout(() => {
                            this.setState({
                                allocationDetail: null,
                                buttonDisabled: true,
                                allocationForm: {
                                    ...this.initAllocationForm,
                                    transaction_date: moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD'),
                                    warehouse_id: allocationDetail.warehouse_id,
                                },
                                only_stocked_item: 'N'
                            }, () => {
                                this.getWarehouseDetail(allocationDetail.warehouse_id, true);

                                // Prepare items for batch fetching
                                const itemsToFetch = consumedItems.map(consumedItem => ({
                                    ...consumedItem,
                                    item: consumedItem.item,
                                    qty: consumedItem.qty,
                                    rate: consumedItem.rate,
                                    isAddRemark: consumedItem?.remark ? true : false
                                }));

                                // Initialize the rows with loading states first
                                this.setState({
                                    allocationItemRows: itemsToFetch.map(i => ({
                                        ...i,
                                        stock_loading: true,
                                        allApiCallsCompleted: false
                                    }))
                                }, () => {
                                    // Call the optimized batch fetcher
                                    this.fetchItemsForAllocation(
                                        itemsToFetch,
                                        this.state.allocationForm.warehouse_id,
                                        { mode: 'edit' } // 'edit' mode preserves indices and maps correctly
                                    );
                                });
                            });
                        }, 500);
                    }

                    if (ParamObject.get('ticketId')) {
                        this.getTicketDetail(ParamObject.get('ticketId'));
                    }
                    if (pr.location && pr.location.state && pr.location.state.addAllocationFromDemand) {

                        let allocationData = pr.location.state.addAllocationFromDemand;
                        let allocationDetail = pr.location.state.addAllocationFromDemand.demandData;

                        let allocationItems = allocationDetail?.items && allocationDetail?.items.length > 0 ? allocationDetail?.items : allocationData?.items && allocationData?.items.length > 0 ? allocationData?.items : [];

                        const {allocation_for, workstation_id, selected_workstation, employee_id, selected_employee, sub_assembly_id, selected_subassembly, asset_id, selected_asset, customer_id, selected_customer, vendor_id, selected_vendor}    =   this.demandForData(allocationDetail);

                        

                        setTimeout(() => {
                            this.setState({
                                allocationDetail: null,
                                buttonDisabled: true,
                                allocationForm: {
                                    ...this.initAllocationForm,
                                    transaction_date: moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD'),
                                    warehouse_id: allocationDetail?.warehouse.id,

                                    demand_transaction_id: allocationDetail?.transaction_id ? allocationDetail?.transaction_id : '',
                                    ticket_id: allocationDetail?.ticket_id ? allocationDetail?.ticket_id : '',

                                    allocation_for,
                                    asset_id,
                                    workstation_id,
                                    employee_id,
                                    sub_assembly_id,
                                    customer_id,
                                    vendor_id,
                                },

                                forData                         :   {
                                    ...this.state.forData, 
                                    ticketSelected : allocationDetail?.ticket_id ? true : false,
                                    editData : {
                                        ...this.state.forData.editData,
                                        // chageWarehouse : !this.state.forData.chageWarehouse,
                                        type           :   allocation_for, 
                                        workstation_id, selected_workstation,
                                        employee_id, selected_employee,
                                        asset_id, selected_asset,
                                        sub_assembly_id, selected_subassembly,
                                        customer_id, selected_customer, 
                                        vendor_id, selected_vendor
                                    }
                                },

                                selectedTicket: allocationDetail?.ticket ? {
                                    asset_id: allocationDetail?.asset ? allocationDetail?.asset.asset_id : null,
                                    value: allocationDetail?.ticket_id ? allocationDetail?.ticket_id : '', label: `${allocationDetail?.ticket.activity_id} : ${allocationDetail?.ticket.header}`, display_label: `${allocationDetail?.ticket.activity_id} : ${allocationDetail?.ticket.header}`
                                } : null
                            }, () => {
                                this.getWarehouseDetail(allocationDetail?.warehouse.id, true);
                                let assetProfile = allocationDetail?.asset;
                                if (assetProfile) {
                                    this.setState({ selectedAsset: { ...assetProfile, label: `${assetProfile.name} (${assetProfile.asset_code})` } });
                                }

                                let employeeProfile = allocationDetail?.employee;
                                if (employeeProfile) {
                                    this.setState({ searchedEmployee: { value: employeeProfile.enc_id, label: `${employeeProfile.name}` } });
                                }
                                let subAssemblyProfile = allocationDetail?.sub_assembly;
                                if (subAssemblyProfile) {
                                    this.setState({ searchSubassembly: { value: subAssemblyProfile.id, label: `${subAssemblyProfile.name}` } });
                                }
                                let workStation = allocationDetail?.workstation;
                                if (workStation) {
                                    this.setState({ searchedWorkstation: { value: workStation.id, label: `${workStation.workstation_name}` } });
                                }
                                if (allocationDetail?.transaction_id) {
                                     this.fetchAllDemandListing(allocationDetail.demand_transaction_id)
                                }
                                   this.setState({
                                allocationItemRows: allocationItems.map(item => ({
                                    ...item,
                                    item: item.item,
                                    qty: item.qty,
                                    rate: item.rate,
                                    remark: item.remark || '',
                                    stock_loading: true,
                                    allApiCallsCompleted: false,
                                    demand_pending_qty: item.pending_qty ? item.pending_qty : 0,
                                     demand_item_id: item.demand_item_id || 0,
                                     demand_transaction_id: allocationDetail?.transaction_id || 0,
                                    isAddRemark : item?.remark ? true : false
                                }))
                            }, () => {

                                // 🔥 Call API ONCE for all items
                                this.fetchItemsForAllocation(
                                    allocationItems,
                                    this.state.allocationForm.warehouse_id,
                                    { mode: 'edit' }
                                );

                            });
                              
                            });
                        }, 500)

                    }
                    
                });
            }).then(() => {
                if (pr.location && pr.location.state && pr.location.state.addAllocationFromDemand) {
                    setTimeout(() => {
                        this.setState({form_loading : false});
                    }, 1000)
                }else { 
                    let ParamObject = new URLSearchParams(this.props.location.search);
                    if (!ParamObject.get('ticketId')) {
                        this.setState({ form_loading: false });
                    }
                }
            });

        // if(!this.state.allocationFormDataLoaded) {      
        // }
    }

    getTicketDetail         =   (ticket_id) => {
        let params              =   {
            need_total_expense      :   "Y",
            need_ticket_allocation  :   "Y",
            need_ticket_consumption :   "Y",
            need_ticket_demand      :   "Y",
            need_parent_ticket      :   "Y",
            need_child_tickets      :   "Y",
        };
        HttpAPICall.withAthorization("GET", this.ticketDetailUrl + "/" + ticket_id, this.props.access_token, params, {}, (resp) => {
            let ticketData      =   resp.data.data;
            // console.log('ticket', ticketData);
            let ticketForData   =   null;
            let asset           =   null;
            if (ticketData.ticket_for === "sub_assembly") {
                ticketForData = ticketData.subAssembly && ticketData.subAssembly;
            } else if (ticketData.ticket_for === "employee") {
                ticketForData = ticketData.employee && ticketData.employee;
            } else if (ticketData.ticket_for === "workstation") {
                ticketForData = ticketData.workStation && ticketData.workStation;
            } else if (ticketData.ticket_for === "site") {
                ticketForData = ticketData.site && ticketData.site;
            } else if (ticketData.ticket_for === "asset") {
                // asset           =   ticketData.asset  
                ticketForData   =   ticketData.asset && ticketData.asset;
            }

            let site_id         =   ticketData?.site?.id;
            let ticket_header   =   ticketData.header;
            let ticketFor       =   ticketData.ticket_for
            const warehouses = this.props.all_warehouses.map((s) => ({
                value: s.id,
                label: `${s.name} (${s.code})`,
                site_id: s.site_ids
            }));

            const { workstation_id, selected_workstation,
                employee_id, selected_employee,
                sub_assembly_id, selected_subassembly,
                asset_id, selected_asset
            } = this.ticketForData(ticketForData, ticketFor)

            this.setState({
                ticketFromTicket: true,
                allocation_for: ticketFor,
                ticketSelectedSite: site_id ? site_id : '',
                ticketSelectedAsset: ticketFor === 'asset' && ticketForData ? ticketForData : null,
                selectedAsset: ticketFor === 'asset' && ticketForData ? { ...ticketForData, label: `${ticketForData?.name} (${ticketForData?.asset_code})` } : null,

                forData: {
                    ...this.state.forData,
                    chageWarehouse: !this.state.forData.chageWarehouse,
                    ticketSelected: ticketForData  ? true : false,
                    editData: {
                        ...this.state.forData.editData,
                        type: ticketFor,
                        workstation_id,
                        selected_workstation,
                        employee_id,
                        selected_employee,
                        asset_id,
                        selected_asset,
                        sub_assembly_id,
                        selected_subassembly,
                    }
                },

                allocationForm: {
                    ...this.initAllocationForm,
                    allocation_for: ticketFor,
                    asset_id: ticketForData && ticketFor === 'asset' && ticketForData ? ticketForData.asset_id : "",
                    ticket_id: ticket_id,
                    sub_assembly_id: ticketForData && ticketFor === 'sub_assembly' && ticketForData ? ticketForData.enc_id : "",
                    workstation_id: ticketForData && ticketFor === 'workstation' && ticketForData ? ticketForData.id : "",
                    employee_id: ticketForData && ticketFor === 'employee' && ticketForData ? ticketForData.enc_id : "",
                },
                searchSubassembly: ticketFor === 'sub_assembly' && ticketForData ? {
                    label: ticketForData.name,
                    value: ticketForData.enc_id,
                    display_label: ticketForData.name,
                    subAssembly: ticketForData
                } : null,
                searchedEmployee: ticketFor === 'employee' && ticketForData ? {
                    value: ticketForData.enc_id,
                    label: ticketForData.display_full_name,
                    employee: ticketForData
                } : null,
                ticketFromAllocation: ticket_id && ticketFor !== 'site' ? true : false,
                allWarehouses: warehouses.filter(wd =>
                    Array.isArray(wd.site_id) && wd.site_id.includes(site_id)
                ),
                selectedTicket: ticket_header ? {
                    asset_id: asset ? asset.asset_id : '',
                    value: ticket_id,
                    label: `${ticket_id} : ${ticket_header}`,
                    display_label: `${ticket_id} : ${ticket_header}`
                } : null
            }, () => {
                let workstation = ticketForData && ticketFor === 'workstation' ? ticketForData : null;
                if (workstation) {
                    this.setState({ searchedWorkstation: { value: workstation.id, label: workstation.name } });
                }

            });
        }).then(() => {
            this.setState({ form_loading: false });


        });

    }

    
    onWarehouseChange = (selectedOption) => {
        const newWarehouseId = selectedOption ? selectedOption.value : null;
       
        if (!this.state.selectedTicket) {
            this.setState({
                selectedAsset: null,
                searchedWorkstation: null,
                searchedEmployee: null,
                searchSubassembly: null,
                warehouseSites: [],
                itemDemandLoaded: false,
                allDemandListing: [],
                allItemWiseDemandListing: [],
                forData: { ...this.state.forData, ticketSelected: false /* ... other resets */ },
                allocationForm: {
                    ...this.state.allocationForm,
                    warehouse_id: newWarehouseId, // Set new ID immediately
                    workstation_id: '',
                    asset_id: '',
                    employee_id: '',
                    sub_assembly_id: '',
                    demand_transaction_id: ''
                },
            }, () => {
                
                // Trigger stock refresh for existing items
                this.refreshAllItemsStock(newWarehouseId);
            });
        } else {
            // If ticket is selected, just update warehouse and refresh stock
            this.setState({
                allocationForm: { ...this.state.allocationForm, warehouse_id: newWarehouseId }
            }, () => {
                this.refreshAllItemsStock(newWarehouseId);
            });
        }
        this.getWarehouseDetail(newWarehouseId);
    }

    refreshAllItemsStock = (warehouse_id) => {
        if (!warehouse_id) return;

        // Filter rows that actually have an item selected
        // Filter rows that actually have an item selected
        const itemsToRefresh = this.state.allocationItemRows.filter(row => row.item && row.item.id);
        if (itemsToRefresh.length > 0) {
            // Set loading state for rows being updated
            const loadingRows = this.state.allocationItemRows.map(row =>
                row.item ? { ...row, stock_loading: true, allApiCallsCompleted: false } : row
            );

            this.setState({ allocationItemRows: loadingRows, buttonDisabled: true }, () => {
                // Use the batch fetcher with the new warehouse_id
                this.fetchItemsForAllocation(
                    itemsToRefresh,
                    warehouse_id,
                    { mode: 'edit' } // 'edit' mode preserves indices
                );
            });
        }
    }
   
    
    getWarehouseDetail                  =   (warehouse_id, editallocation=false)  =>  {
        if (warehouse_id) {
            this.setState({
                warehouseDetailLoading : true, 
                warehouseDetail : null, 
                warehouseSites : [],
                forData                 :   {...this.state.forData, chageWarehouse  :  false}});
            HttpAPICall.withAthorization('GET', this.warehouseUrl + '/' + warehouse_id, this.props.access_token, {}, {}, (resp) => {
                let respData = resp.data;
                this.setState({
                    warehouseDetail         :   respData.data,
                    warehouseSites          :   respData.data.sites,
                    forData                 :   {...this.state.forData, warehouseSites : respData.data.sites, chageWarehouse  : true},
                });
              
            }).then(() => {
                this.setState({warehouseDetailLoading : false});
            });
        } else {
            this.setState({warehouseDetail: null})
        }
    }

    onItemSelect = (
        selectedOption,
        key,
        qty = 1,
        allocation_price = null,
        pre_selected_stock = null,
        addRow = true,
        fromPickItem = false
    ) => {

        if (!selectedOption) return;

        let allocationItemRows = [...this.state.allocationItemRows];
        let itemdata = selectedOption.itemdata;

        /* ================= RATE LOGIC ================= */
        if (
            this.props.location.state &&
            this.props.location.state.addAllocationFromPurchase &&
            selectedOption.item_with_discount &&
            selectedOption.qty
        ) {
            const calculatedRate =
                parseFloat(selectedOption.item_with_discount) /
                parseFloat(selectedOption.qty);
            allocation_price = parseFloat(calculatedRate.toFixed(2));
        } else if (!allocation_price) {
            allocation_price = itemdata?.allocation_price || 0;
        }

        allocationItemRows[key] = {
            ...allocationItemRows[key],

            item: itemdata,
            qty: Number(qty || 0),
            rate: allocation_price || itemdata?.consumption_price || '',
            remark: selectedOption.remark || '',

            demand_pending_qty: selectedOption.demand_pending_qty || 0,
            demand_item_id: selectedOption.demand_item_id || '',
            demand_transaction_id: selectedOption.demand_transaction_id || '',

            allocation_item_id: pre_selected_stock?.allocation_item_id || null,
            pending_qty: pre_selected_stock?.pending_qty || 0,

            // ✅ FIXED
            item_current_qty: Number(qty || 0),

            stock_loading: itemdata?.category === 'goods',
            allApiCallsCompleted: itemdata?.category !== 'goods'
        };

        this.setState({ allocationItemRows }, () => {

            if (!this.state.allocationItemRows.find(ir => !ir.item) && addRow) {
                setTimeout(() => this.addNewItemRow(), 300);
            }

            if (itemdata && itemdata.category === 'goods') {


                // ADD MODE
                this.fetchItemsForAllocation(
                    [{
                        item: itemdata,
                        item_id: itemdata.id,
                        qty: qty
                    }],
                    this.state.allocationForm.warehouse_id,
                    { mode: 'add', targetIndex: key }
                );
                // }
            }
        });
    };

    fetchItemsForAllocation = (
        allocationItems = [],
        warehouse_id,
        { mode = 'edit', targetIndex = null, cb = null } = {}
    ) => {
        if (!Array.isArray(allocationItems) || allocationItems.length === 0) return;
        if (mode === 'add' && typeof targetIndex !== 'number') return;

        // Get Unique IDs to prevent redundant data fetching
        const item_ids = [...new Set(allocationItems
            .map(i => i.item?.id || i.itemdata?.id || i.itemData?.id || i.item_id || i.id)
            .filter(Boolean))];

        if (item_ids.length === 0) return;

        HttpAPICall.withAthorization(
            'GET',
            this.itemsUrl,
            this.props.access_token,
            {
                item_ids,
                warehouse_id,
                current_stock: 'Y'
            },
            {},
            (resp) => {
                const itemsData = resp?.data?.data || [];
                // Even if itemsData is empty, we must stop the loaders
                this.handleAllocationItems(
                    itemsData,
                    allocationItems,
                    { mode, targetIndex }
                );

                if (typeof cb === 'function') cb();
            }
        );
    };

   handleAllocationItems = (
    itemsData = [],
    allocationItems = [],
    { mode = 'edit', targetIndex = null } = {}
) => {
    let allocationItemRows = [...this.state.allocationItemRows];

    // 1. If in Edit/Initial mode, ensure the row count matches the source items
    if (mode === 'edit' && allocationItemRows.length < allocationItems.length) {
        allocationItemRows = allocationItems.map(() => ({
            item: null, qty: 1, rate: 0, current_stocks: [], selected_stock: null,
            stock_loading: true, allApiCallsCompleted: false
        }));
    }

    const apiDataMap = new Map(itemsData.map(item => [item.id, item]));

    const updatedRows = allocationItemRows.map((row, index) => {
        if (mode === 'add' && index !== targetIndex) return row;

        const sourceItem = mode === 'add' ? allocationItems[0] : allocationItems[index];
        if (!sourceItem) return row;

        const itemId = sourceItem.item?.id || sourceItem.itemdata?.id || sourceItem.item_id || sourceItem.id;
        const apiItem = apiDataMap.get(itemId);

        if (!apiItem) {
            return { ...row, stock_loading: false, allApiCallsCompleted: true };
        }

        const current_stock = apiItem.current_stock || [];
        let current_stocks = current_stock.map(cs => ({
            value: cs?.total_qty || 0,
            label: (
                <Ax>
                    BN: <b>{cs?.batch_number}</b><br />
                    ED: <b>{cs?.expiry_date_display}</b><br />
                    Stock: <b>{cs?.total_qty}</b> | Free: <b>{cs?.free_qty}</b>
                </Ax>
            ),
            stock: cs,
            batch_number: cs?.batch_number,
            expiry_date: cs?.expiry_date,
            expiry_date_display: cs?.expiry_date_display,
            stock_qty: cs?.total_qty,
            free_qty: cs?.free_qty,
            display_label: `${cs?.batch_number} & ${cs?.expiry_date_display}`
        }));

        // Preserve Original Batch Logic for Edit Mode
        // if (mode === 'edit') {
        //     // Check for match based on both Batch Number AND Expiry Date
        //     const exists = current_stocks.some(cs => 
        //         cs.batch_number === sourceItem.batch_number && 
        //         cs.expiry_date === sourceItem.expiry_date
        //     );

        //     if (!exists) {
        //         current_stocks.unshift({
        //             value: sourceItem.qty,
        //             label: <Ax>BN: <b>{sourceItem.batch_number}</b> (Original)</Ax>,
        //             stock: { ...sourceItem, total_qty: sourceItem.qty, free_qty: sourceItem.qty },
        //             batch_number: sourceItem.batch_number,
        //             expiry_date: sourceItem.expiry_date,
        //             expiry_date_display: sourceItem.expiry_date_display || sourceItem.expiry_date,
        //             is_original_allocation_batch: true,
        //             display_label: `${sourceItem.batch_number} (Original)`,
        //             stock_qty: sourceItem.qty,
        //             free_qty: sourceItem.qty
        //         });
        //     }
        // }

        // Determine selected stock: 
        // 1. Default to first available stock
        let selected_stock = current_stocks.length > 0 ? current_stocks[0] : null;

        // 2. If sourceItem has batch details, find exact match (Batch + Expiry)
        if (sourceItem) {
            const matched = current_stocks.find(cs => 
                cs.batch_number === sourceItem.batch_number && 
                cs.expiry_date === sourceItem.expiry_date
            );
            if (matched) selected_stock = matched;
        }
        return {
            ...row,
            item: {...apiItem,isAddRemark : sourceItem.remark ? true : false},
            remark :  sourceItem.remark ? sourceItem.remark : "",
            qty: Number(sourceItem.pending_qty || sourceItem.qty || 1),
            rate: Number(sourceItem.rate || apiItem.consumption_price || 0),
            current_stocks,
            selected_stock,
            free_qty: selected_stock ? selected_stock.free_qty : 0,
            stock_qty: selected_stock ? selected_stock.stock_qty : 0,
            allocation_item_id: sourceItem.allocation_item_id || row.allocation_item_id || null,
            demand_item_id: sourceItem.demand_item_id || '',
            stock_loading: false,
            allApiCallsCompleted: true,
            demand_pending_qty : sourceItem.demand_pending_qty || 0
        };
    });

    this.setState({
        allocationItemRows: updatedRows,
        buttonDisabled: false
    });
};

    afterSelectForData = (data) => {
        let workstation_id = '', asset_id = '', employee_id = '', sub_assembly_id = '', vendor_id = '', customer_id = '';

        if (data && data.type) {
            switch (data.type) {
                case 'asset':
                    asset_id = data.asset_id;
                    break;
                case 'workstation':
                    workstation_id = data.workstation_id;
                    break;
                case 'employee':
                    employee_id = data.employee_id;
                    break;
                case 'sub_assembly':
                    sub_assembly_id = data.sub_assembly_id;
                    break;
                case 'vendor':
                    vendor_id = data.vendor_id;
                    break;
                case 'customer':
                    customer_id = data.customer_id;
                    break;
                default:
                    return null;
            }
        }

        this.setState({
            allocationForm: {
                ...this.state.allocationForm,
                allocation_for: data ? data.type : "",
                workstation_id,
                asset_id,
                employee_id,
                sub_assembly_id,
                vendor_id,
                customer_id,
                demand_transaction_id: ''
            },
            allDemandListing: [],
            allItemWiseDemandListing: [],
            buttonDisabled: false,
        }, () => {
            if (this.state.allocationForm.warehouse_id &&
                (asset_id || workstation_id || employee_id || sub_assembly_id || vendor_id || customer_id)) {
                this.fetchAllDemandListing();
            }
        });
    }

    fetchAllDemandListing = (transaction_id) => {
        if (!this.state.allocationForm.warehouse_id ||
            !this.state.allocationForm.allocation_for) {
            return;
        }

        this.setState({ demand_listing_loading: true });

        let params = {
            action: 'data',
            search_transaction_id : transaction_id ? transaction_id : null,
            search_warehouse_ids: [this.state.allocationForm.warehouse_id],
            search_demand_for: this.state.allocationForm.allocation_for,
            search_asset_ids: this.state.allocationForm.asset_id ? [this.state.allocationForm.asset_id] : [],
            search_employee_ids: this.state.allocationForm.employee_id ? [this.state.allocationForm.employee_id] : [],
            search_workstation_ids: this.state.allocationForm.workstation_id ? [this.state.allocationForm.workstation_id] : [],
            search_sub_assembly_ids: this.state.allocationForm.sub_assembly_id ? [this.state.allocationForm.sub_assembly_id] : [],
            search_status_levels: [3, 4], // Approved demands
           // min_pending_qty: 0.01,
            per_page: 1000,
            page: 1
        };
        if(!transaction_id){
            params = {...params,min_pending_qty : 0.01}
        }

        HttpAPICall.withAthorization('GET', this.reportUrl, this.props.access_token, params, null, (resp) => {
            let respData = resp.data;

            // For dropdown options (unique transactions)
            const uniqueTransactions = Array.from(
                new Map(
                    respData.data?.map(dt => [
                        dt.transaction_id,
                        {
                            value: dt.transaction_id,
                            label: dt.transaction_id,
                            transaction_date: dt.transaction_date
                        }
                    ]) || []
                ).values()
            );

            // For item-wise listing
            const itemDemandList = respData.data?.map(dt => ({
                value: dt.transaction_id,
                label: dt.transaction_id,
                demand_data: dt,
            })) || [];

            this.setState({
                allDemandListing: uniqueTransactions,
                allItemWiseDemandListing: itemDemandList,
                demand_listing_loading: false
            });
        }).catch((error) => {
            console.error('Error fetching demand listing:', error);
            this.setState({ demand_listing_loading: false });
        });
    }

    getItemInventoryLevel = (item_id, key, pre_selected_stock = null, item_category = 'goods') => {
        this.setState({ buttonDisabled: true });
        let allocationItemRows = this.state.allocationItemRows;

        if (item_category == 'goods') {
            allocationItemRows[key] = { ...allocationItemRows[key], stock_loading: true };
            this.setState({ allocationItemRows: [...allocationItemRows] });

            let params = { interchangeable_items_current_stock: "N", warehouse_id: this.state.allocationForm.warehouse_id };

            HttpAPICall.withAthorization('GET', this.itemCurrentStockUrl + '/' + item_id, this.props.access_token, params, {}, (resp) => {
                let current_stocks = resp.data.current_stock.map(cs => {
                    return {
                        value: cs.qty,
                        label: (<Ax>BN: <b>{cs.batch_number}</b> <br />
                            ED: <b> {cs.expiry_date_display}</b><br />
                            Stock in hand: <b> {cs.qty} </b> <br />
                            Free Stock: <b> {cs.free_qty} </b></Ax>),
                        stock: cs,
                        display_label: `${cs.batch_number} & ${cs.expiry_date_display}`
                    }
                });

                let allocationItemRows = this.state.allocationItemRows;

                // FOR EDIT CASE: If we have a pre-selected stock from the allocation being edited,
                // but it's not found in current stock, we need to preserve it
                if (pre_selected_stock && pre_selected_stock.batch_number) {
                    const stockExists = current_stocks.some(cs =>
                        cs.stock.batch_number === pre_selected_stock.batch_number &&
                        cs.stock.expiry_date === pre_selected_stock.expiry_date
                    );

                    if (!stockExists) {
                        // Add the original batch from the allocation to the current stocks list
                        current_stocks.unshift({
                            value: pre_selected_stock.qty,
                            label: (<Ax>BN: <b>{pre_selected_stock.batch_number}</b> <br />
                                ED: <b> {pre_selected_stock.expiry_date_display || pre_selected_stock.expiry_date}</b><br />
                                Stock in hand: <b> {pre_selected_stock.qty} </b> <br />
                                Free Stock: <b> {pre_selected_stock.qty} </b> <br />
                                <i>(Original allocation batch)</i></Ax>),
                            stock: {
                                ...pre_selected_stock,
                                free_qty: pre_selected_stock.qty,
                                expiry_date_display: pre_selected_stock.expiry_date_display || pre_selected_stock.expiry_date
                            },
                            display_label: `${pre_selected_stock.batch_number} & ${pre_selected_stock.expiry_date_display || pre_selected_stock.expiry_date}`,
                            is_original_allocation_batch: true // Flag to identify original batches
                        });
                    }
                }

                allocationItemRows[key] = {
                    ...allocationItemRows[key],
                    stock_loading: false,
                    current_stocks: current_stocks,
                    allApiCallsCompleted: true
                };

                let selectedStock = current_stocks.length > 0 ? current_stocks[0] : null;

                // FOR EDIT CASE: Pre-select the original batch if available
                if (pre_selected_stock && pre_selected_stock.batch_number) {
                    const originalStock = current_stocks.find(cs =>
                        cs.stock.batch_number === pre_selected_stock.batch_number &&
                        cs.stock.expiry_date === pre_selected_stock.expiry_date
                    );

                    if (originalStock) {
                        selectedStock = {
                            ...originalStock,
                            allocation_item_id: pre_selected_stock.allocation_item_id,
                            stock: {
                                ...originalStock.stock,
                                // Preserve the original quantity for edit case
                                qty: this.state.allocationDetail ? pre_selected_stock.qty : originalStock.stock.qty,
                                free_qty: this.state.allocationDetail ?
                                    (originalStock.stock.free_qty + pre_selected_stock.qty) :
                                    originalStock.stock.free_qty
                            }
                        };
                    }
                }

                this.setState({ allocationItemRows: [...allocationItemRows] }, () => {
                    this.onBatchChange(selectedStock, key);
                    this.handleButtonEnable();
                });
            }).then(() => { });
        } else {
            allocationItemRows[key] = { ...allocationItemRows[key], stock_loading: false, allApiCallsCompleted: true };
            this.setState({ allocationItemRows: [...allocationItemRows] });
        }
    }

    handleButtonEnable                  = () => {
        const allApiCallsCompleted = this.state.allocationItemRows.filter(i => i.item ? true : false).every(item => item.allApiCallsCompleted);
        this.setState({ buttonDisabled: !allApiCallsCompleted });
    };
    
    onBatchChange                       =   (selectedOption, key)  =>  {
        if(selectedOption && selectedOption.stock) {
            let selected_stock              =   selectedOption.stock;
            let allocationItemRows         =   this.state.allocationItemRows;
            allocationItemRows[key]        =   {
                ...allocationItemRows[key], 
                selected_stock  :   selected_stock,
                stock_qty       :   selected_stock.qty,
                free_qty        :   selected_stock.free_qty,
                allocation_item_id        :   selectedOption && selectedOption.allocation_item_id ?  selectedOption.allocation_item_id : null,
            };
            this.setState({allocationItemRows : [...allocationItemRows]});
        }
    }

    onDemandChange = (selectedOption) => {
        if (selectedOption && selectedOption.value) {
            this.setState({
                allocationForm: {
                    ...this.state.allocationForm,
                    demand_transaction_id: selectedOption.value
                },
                allocationItemRows: [...this.initAllocationItemRows] // Clear existing rows
            }, () => {
                // Load items from selected demand
                this.loadDemandItems(selectedOption.value);
            });
        } else {
            // Clear demand transaction and reset items
            this.setState({
                allocationItemRows: [...this.initAllocationItemRows],
                allocationForm: {
                    ...this.state.allocationForm,
                    demand_transaction_id: ''
                }
            });
        }
    }

    loadDemandItems = (transaction_id) => {
        if (!transaction_id) return;

        // Filter items for the selected demand
        const filteredItems = this.state.allItemWiseDemandListing
            .filter(item => item.value === transaction_id)
          
            .map(item => ({
                item: item.demand_data?.item_profile || null,
                item_id: item.demand_data?.item_id || item.demand_data?.item_profile?.id,
                qty: item.demand_data?.pending_qty || item.demand_data?.qty || 0,
                rate : item.demand_data?.rate || 0,
                demand_item_id: item.demand_data?.demand_item_id || '',
                demand_pending_qty: item.demand_data?.pending_qty || item.pending_qty || 0,
                demand_transaction_id: transaction_id
            }));

        if (filteredItems.length === 0) return;

        // Use fetchItemsForAllocation to load items with current stock
        this.fetchItemsForAllocation(
            filteredItems,
            this.state.allocationForm.warehouse_id,
            {
                mode: 'edit',
                cb: () => {
                    console.log('Demand items loaded successfully');
                }
            }
        );
    }

    itemViewModalInit                       =   (item,k)  =>  {
        if(item){
            this.itemDetailsRef.current.modalInit(item);
            this.setState({itemRowNumber : k})
        }
    }

    viewallocationModalInit                       =   (data,k)  =>  {
       if(this.state.allocationForm?.asset_id || this.state.allocationForm?.workstation_id){
            if(data){
                this.setState({    
                    itemSearchedDetails   :    data,
                    itemRowNumber         :    k
                },() => this.allocationHistoryRef.current.modalInit(data,this.state.allocationForm.workstation_id,this.state.allocationForm.asset_id,this.state.allocationForm.allocation_for))   
            }
       }else{
            toast.error('Please Select Asset/Workstation first', { position: toast.POSITION.TOP_RIGHT });
       }
       
    }

    addRemark       =   (data,k)      =>      {
        let allRows                 =   this.state.allocationItemRows;
        let itemdata = {...data,isAddRemark : true}
        allRows[k]                  =   {...this.state.allocationItemRows[k] , item  : itemdata};
        this.setState({allocationItemRows : allRows});
    }

    
    itemSearchModalInit             =       ()          =>      {
        this.setState(prevState => ({ showItemSearchModal: !prevState.showItemSearchModal }), () => {
            if (this.state.showItemSearchModal) {
                let allRows                 =   this.state.allocationItemRows;
                let item_ids                =   [];
                if(allRows && allRows.length > 0){
                    item_ids = allRows.filter(i => i.item ? true : false).map(item => {return(item?.item?.id)} )
                }
                if (this.itemSearchRef.current) {
                    this.itemSearchRef.current.searchItemModalInit(item_ids);
                }
            }
        });
        
    }

    editItemModalInit          =       (data,k,pending_qty=0)           =>      {
        
        this.setState(prevState => ({ showItemEditModal: !prevState.showItemEditModal,itemSearchedDetails:{...data,demand_pending_qty : pending_qty},itemRowNumber:k }), () => {
            if (this.state.showItemEditModal) {
                let allRows                 =   this.state.allocationItemRows;
                let item_ids                =   [];
                if(allRows && allRows.length > 0){
                    item_ids = allRows.filter(i => i.item ? true : false).map(item => {return(item?.item?.id)} )
                }
                if(this.editItemModalRef.current){
                    this.editItemModalRef.current.itemEditModalInit(data); 
                }
                
            }
        });
        
    }

    addItemModalInit          =       ()           =>      {
        this.setState(prevState => ({ showItemAddModal: !prevState.showItemAddModal }), () => {
            if (this.state.showItemAddModal) {
                let allRows                 =   this.state.allocationItemRows;
                let item_ids                =   [];
                if(allRows && allRows.length > 0){
                    item_ids = allRows.filter(i => i.item ? true : false).map(item => {return(item?.item?.id)} )
                }

                if(this.addItemModalRef.current){
                    this.addItemModalRef.current.itemAddModalInit(); 
                }
            
            }
        });
        
    }

     //********************EDIT ITEM DETAILS ******************************* */


    submitEditItem          =       ()      =>      {
        HttpAPICall.withAthorization('GET',this.itemDetailUrl + '/' + this.state.itemSearchedDetails.id, this.props.access_token, null, null, (response) => {
           let selectedItem = {
                label               :   (<Ax>
                                            <b>Item : </b> {response.data.data.name} <small> ({response.data.data.item_code})</small><br/>
                                            <small>
                                                <b>Manufacturer : </b> {response.data.data.manufacturer ? response.data.data.manufacturer.name : ''}<br/>
                                                <b>MPN : </b> {response.data.data.manufacturer_part_no}</small></Ax>),
                value               :   response.data.data.id ,
                display_label       :   `${response.data.data.name} (${response.data.data.item_code})`,
                itemdata            :   response.data.data
            };
            this.setState({
                  itemSearchedDetails        :    {...this.state.itemSearchedDetails,...response.data.data}
               },() => {
                   this.onItemSelect({...selectedItem,itemdata:response.data.data,demand_pending_qty : this.state.itemSearchedDetails && this.state.itemSearchedDetails.demand_pending_qty ? this.state.itemSearchedDetails.demand_pending_qty : 0},this.state.itemRowNumber,this.state.allocationItemRows[this.state.itemRowNumber]?.qty)
               });
        })
       
    }
    
    addNewItemRow                       =   ()  =>  {
        this.setState({allocationItemRows : [...this.state.allocationItemRows, ...this.initAllocationItemRows ] });
    }

    removeItemRow                       =   (k) =>  {
        let allocationItemRows             =   this.state.allocationItemRows;
        if(allocationItemRows.length > 1) {
            allocationItemRows.splice(k, 1);
            this.setState({allocationItemRows : allocationItemRows});
        }
    }

     //****************************CLOSE allocation *********************/
    closeEvent              =           ()      =>      {
        if(this.state.allocationDetail){
            this.props.history.push({pathname: `/allocation_list`, state: {allocationData : this.state?.allocationDetail }})
        }else{
            this.props.history.push({pathname: `/allocation_list`})
        }
    }

    addItemsfromSearch          =       (selectedItems)     =>  {
        let allocationItemRows = selectedItems.map((pu_item, k) => {
            return {
                item                        :          {...pu_item.item,isAddRemark : pu_item.remark ? true : false},
                req_allocation_loading      :           true,
                req_allocation              :           [],
                id                          :           pu_item.item.id,
                qty                         :           pu_item.qty,
                rate                        :           pu_item.rate,
                remark                      :           '',
                gst                         :           pu_item.gst,
                discount_type               :           '',
                discount_rate               :           '',
                po_item_id                  :           '',
                req_item_id                 :           '',
                selected_allocation         :           null,
                expiry_date                 :           '',
                batch_number                :           '',
                stock_id                    :           null,
            };
        });
        let allRows = this.state.allocationItemRows ?  this.state.allocationItemRows.filter(i => i.item ? true : false) : [];
        let allocationItems = allRows.concat(allocationItemRows);
        allocationItems.forEach((consumedItem, key) => {
            this.onItemSelect({...consumedItem , itemdata : {...consumedItem.item,isAddRemark : consumedItem?.remark ? true : false}}, key ,consumedItem.qty, consumedItem.rate,false,false);
        });
        
    
    }

    allocationFormSubmitHandler = (event, status = 1) => {
        event.preventDefault();
        let showErrors = [];
        let formData = {
            ...this.state.allocationForm,
            status: status,
            transaction_date: moment(this.state.allocationForm.transaction_date, 'YYYY-MM-DD').format('YYYY-MM-DD'),
            // employee_id: this.state.allocationForm.allocation_for === "employee" && this.state.searchedEmployee ? this.state.searchedEmployee.value : ''
        };
    
       
        let items = this.state.allocationItemRows.filter(ir => ir.item).map(i => {
            return {
                id: i.item.id,
                batch_number: i.selected_stock ? i.selected_stock.batch_number : '',
                expiry_date: i.selected_stock ? i.selected_stock.expiry_date : '',
                allocation_item_id: i.allocation_item_id ? i.allocation_item_id : '',
                qty: i.qty,
                free_qty: i.item.category !== "services" ? i.free_qty : i.qty,
                rate: i.rate,
                remark: i.remark,
                demand_item_id: i.demand_item_id,
                demand_pending_qty: i.demand_pending_qty ? i.demand_pending_qty : 0,
                demand_transaction_id: this.state.allocationForm.demand_transaction_id
            };
        })
        console.log(formData,'data')
    
        // Validate basic fields
        if (formData.transaction_date === '') {
            showErrors = [...showErrors, 'Please enter Transaction Date.'];
        }
    
        if (formData.warehouse_id === '') {
            showErrors = [...showErrors, 'Please select Warehouse.'];
        }
    
        if (formData.allocation_for === '') {
            showErrors = [...showErrors, 'Please select allocation for.'];
        }
    
        if (formData.allocation_for === 'asset') {
            if (formData.asset_id === '') {
                showErrors = [...showErrors, 'Please select Asset.'];
            }
        } else if (formData.allocation_for === 'workstation') {
            if (formData.workstation_id === '') {
                showErrors = [...showErrors, 'Please select Workstation.'];
            }
        }
    
        if (items.length === 0) {
            showErrors = [...showErrors, 'Please select Item and their allocation qty.'];
        } else if (items.find(i => parseFloat(i.qty) <= 0)) {
            showErrors = [...showErrors, 'Every Item\'s allocation qty must be more than 0.'];
        } else if (status === '34') {
            if (items.find(i => i.qty > i.free_qty)) {
                showErrors = [...showErrors, 'In Allocate Items, allocation qty must be less than Free Qty.'];
            }
        } else if (this.state.negative_stock === 'N') {
            if (items.find(i => i.qty > i.free_qty)) {
                showErrors = [...showErrors, 'allocation qty can not more than Free Qty.'];
            }
        }
    
        
        if (showErrors.length > 0) {
            toast.error(showErrors[0], { position: toast.POSITION.TOP_RIGHT });
        } else {
            formData = {
                ...formData,
                items: items,
            };
           
            if (this.state.allocationDetail) {
                this.setState({ saveFormSubmitting: true });
                HttpAPICall.withAthorization('PUT', this.allocationUrl, this.props.access_token, {}, { ...formData, transaction_id: this.state.allocationDetail.transaction_id }, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    this.props.history.push({ pathname: `/allocation_list`, state: { allocationId: response.data.transaction_id } });
                }).then(() => this.setState({ saveFormSubmitting: false }));
            } else {
                this.setState({ saveFormSubmitting: true });
                HttpAPICall.withAthorization('POST', this.allocationUrl, this.props.access_token, {}, formData, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    this.props.history.push({ pathname: `/allocation_list`, state: { allocationId: response.data.transaction_id } });
                }).then(() => this.setState({ saveFormSubmitting: false }));
            }
        }
    }
    
   pickItemModalInit        =       ()          =>      {
       this.pickItemModal.show()
   }

    pickItemDemandModalInit        =       ()      =>      {
        this.pickItemDemandModal.show();
      
    }


    pageTitlejsx                        =   ()  =>  {
        return (<div className="page_title row m0">
            <div className="col-12">
                <h3>{this.state.allocationDetail ? "Edit" : "New"} Allocation {this.state.allocationDetail ? <span> of Transaction ID : {this.state.allocationDetail.transaction_id}</span> : null}</h3>
                <div className="text-end mt15">
                    <button onClick={this.closeEvent} disabled={this.state.saveFormSubmitting ? true : false} type="button" className="btn btn-secondary">
                        <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="Close Requisition" />
                    </button>
                </div>
            </div>
        </div>);
    }
    
    allocationItemsJsx                 =   ()  =>  {
        return (<div className="my-3 row">
            <div className="col-sm-12">
                <table className="table table-bordered table-responsive bg-white ">
                    <thead className="table-secondary align-middle">
                        <tr className="">
                            <th scope="col" style={{ width: "5%" }}>S.No</th>
                            <th scope="col" className="text-center" >Item Details</th>
                            <th scope="col" className="text-center" style={{ width: "12%" }}>Demand Pending Qty</th>
                            {this.state.track_batch_expiry == "Y"
                                ? <th scope="col" className="text-center" style={{ width: "18%" }}>Batch Number <br /> Expiry Date</th>
                                : null}
                            <th scope="col" className="text-center" style={{ width: "10%" }}>Quantity</th>
                            <th scope="col" className="text-center" style={{ width: "10%" }}>Unit Rate</th>
                            <th scope="col" className="text-center" style={{ width: "10%" }}>Amount</th>
                            <th scope="col" className="" style={{ width: "5%" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.allocationItemRows.map((itemRow, itemKey) => {
                             let item = itemRow.item;
                           
                            return <tr className="" key={itemKey}>
                                <td className="text-center align-middle">{itemKey + 1}</td>
                                {(item
                                    ? <Ax>
                                        <td>
                                        <div className="row">
                                            <div className='col-sm-10'><span className="fw-bold link-primary cursor_pointer" onClick={() => { this.itemViewModalInit(item); }}>{item.name}</span></div>
                                               
                                                <div className='col-sm-2 text-end'>
                                                    <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid pr10 pl10" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                                    <ul className="dropdown-menu">
                                                        <li><a href="#" className="dropdown-item" onClick={() => { this.itemViewModalInit(item) }}>View Details</a></li>
                                                        {this.props?.permissions?.permissions?.includes("isc-item-edit") &&  <li><a href="#" className="dropdown-item" onClick={() => {this.setState({showItemEditModal : false},() => {this.editItemModalInit(item,itemKey,itemRow.demand_pending_qty ? itemRow.demand_pending_qty : 0 )})  }}>Edit Item</a></li>}
                                                       <li className="dropdown-item" onClick={() => { this.addRemark(itemRow.item, itemKey) }}>Add Remark</li>
                                                    </ul>
                                                </div>
                                            </div>
                                           
                                            <div className="form-text"><b>Code: </b>{item.item_code}</div>
                                            <div className="form-text">
                                                <b>Mfr: </b>{item.manufacturer ? item.manufacturer.name : '-'} (<b>MPN:</b> {item.manufacturer_part_no ? item.manufacturer_part_no : '-'})
                                            </div>
                                            {itemRow.item && itemRow.item.isAddRemark && itemRow.item.isAddRemark == true
                                                ?
                                                <input
                                                    name="remark"
                                                    type="text"
                                                    value={itemRow.remark}
                                                    onChange={(e) => this.dynamicInputHandlerByKey(e, itemKey, 'allocationItemRows')}
                                                    className="form-control mt10"
                                                    autoComplete="off"
                                                    placeholder="Item Remarks"
                                                />
                                                : null}

                                        </td>
                                        
                                      
                                        {
                                            itemRow.stock_loading && item.category == "goods"
                                                ? <td colSpan={this.state.track_batch_expiry == 'Y' ? 5 : 4}><Loader /></td>
                                                : (<Ax>
                                                    <td>
                                                       
                                                        <small className={['my-1',].join(' ')}>
                                                            {this.state.allocationForm.demand_transaction_id ? <><b>Pending Qty: </b> {itemRow.demand_pending_qty} <br /></> : "-"}
                                                        </small>

                                                    </td>
                                                    {this.state.track_batch_expiry == "Y"
                                                        ? <td>
                                                            {item.category == "goods" ? (<Ax>
                                                                {itemRow && itemRow.current_stocks && itemRow.current_stocks.length > 1 ?
                                                                    <TapSelect
                                                                        changeEvent={(selectedOption, e) => { this.onBatchChange(selectedOption, itemKey); }}
                                                                        options={itemRow.current_stocks}
                                                                        isSearchable={false}
                                                                        placeholder="Change"
                                                                        isDisabled={this.state.allocationDetail && itemRow.pending_qty !== itemRow.item_current_qty ? true : false}
                                                                        formatOptionLabel={(option) => (
                                                                            <div className={option.is_original_allocation_batch ? 'text-primary fw-bold' : ''}>
                                                                                {option.display_label}
                                                                            </div>
                                                                        )}
                                                                    />
                                                                    : null}
                                                                <div className='py-1'>
                                                                    Batch Number : <b> {itemRow.selected_stock ? itemRow.selected_stock.batch_number : "-"} </b> <br />
                                                                   Expiry Date : <b> {itemRow.selected_stock ? itemRow.selected_stock.expiry_date_display : "-"} </b><br />
                                                                </div>
                                                            </Ax>) : (<div className="align-middle text-center">-</div>)}
                                                        </td> : null
                                                    }
                                                    
                                                    <td>
                                                        <TapInputNumber
                                                            name="qty"
                                                            value={itemRow.qty}
                                                            onChange={(e) => this.dynamicInputHandlerByKey(null, itemKey, 'allocationItemRows',null,'qty',e)}
                                                            placeholder="Qty"
                                                            required={true}
                                                            min={.01}
                                                            disabled={this.state.allocationDetail && itemRow.pending_qty !== itemRow.item_current_qty ? true  :false}
                                                        />
                                                        <span className="text-helping input-group-text text-end pr0">{item && item.measuring_unit ? item.measuring_unit.name : ''}</span>
                                                        {item.category !== "services" && (
                                                            <small className={['my-1', (itemRow.qty > (itemRow.selected_stock ? itemRow.free_qty : 0)) ? 'text-danger' : ''].join(' ')}>
                                                                <b>Stock In Hand: </b> {itemRow.selected_stock ? itemRow.stock_qty : "Nil"} <br />
                                                                <b>Free Stock: </b> {itemRow.selected_stock ? itemRow.free_qty : "Nil"} <br />
                                                            </small>
                                                        )}
                                                    </td>


                                                    <td>
                                                        <TapInputNumber
                                                            name="rate"
                                                            value={itemRow.rate}
                                                            onChange={(e) => this.dynamicInputHandlerByKey(null, itemKey, 'allocationItemRows',null,'rate',e)}
                                                            placeholder="Unit Rate"
                                                            required={true}
                                                             disabled={this.state.allocationDetail && itemRow.pending_qty !== itemRow.item_current_qty ? true  :false}
                                                        />
                                                    </td>
                                                    <td className="pt-4 text-end">{(itemRow.rate * itemRow.qty).toFixed(2)}</td>

                                                </Ax>)}

                                    </Ax>
                                    : <Ax>
                                        <td className="align-middle">
                                            <InputItemSearch
                                                changeEvent={(selectedOption) => {
                                                    this.onItemSelect(selectedOption, itemKey);
                                                }}
                                                only_stocked_item={this.state.only_stocked_item}
                                                stock_warehouse_ids={[this.state.allocationForm.warehouse_id]}
                                                only_active_item='Y'
                                            />
                                        </td>
                                        <td colSpan={this.state.track_batch_expiry == 'Y' ? 5 : 4}></td>
                                    </Ax>
                                )}
                                <td className="text-center align-middle">
                                    {/* {this.state.allocationDetail && itemRow.item_current_qty == itemRow.pending_qty ? */}
                                        {this.state.allocationItemRows.length > 1 && !this.state.allocationDetail
                                            ? <a href="#" onClick={() => this.removeItemRow(itemKey)}>
                                                <tapIcon.imageIcon icon={tapIcon.CloseCircleIcon} className="img-fluid" />
                                            </a>
                                            : this.state.allocationItemRows.length > 1 && this.state.allocationDetail && itemRow.item_current_qty == itemRow.pending_qty
                                            ? <a href="#" onClick={() => this.removeItemRow(itemKey)}>
                                            <tapIcon.imageIcon icon={tapIcon.CloseCircleIcon} className="img-fluid" />
                                        </a> :  null}
                                        {/* : null} */}
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
            <div className="col-sm-12">
                <div className="row">
                    <div className="col-sm-8">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                value={this.state.only_stocked_item == "Y" ? "N" : "Y"}
                                checked={this.state.only_stocked_item == "Y"}
                                onChange={(e) => { this.setState({ only_stocked_item: e.target.value, }); }}
                                id="onlyStockedItem"
                                // disabled={this.state.negative_stock == 'N' ? true : false}
                            />
                            <label className="form-check-label" htmlFor="onlyStockedItem">
                                Show only those items that are available in the selected warehouse
                            </label>
                        </div>
                    </div>
                    {!this.state.allocationForm.demand_transaction_id &&  <div className="col-sm-4 text-end">
                    {this.state.allocationForm && this.state.allocationForm.warehouse_id  ?
                    <a role="button"  onClick={() => {this.setState({showItemSearchModal : false},() => this.itemSearchModalInit())}} className="link-primary"><tapIcon.FontAwesomeIcon icon={tapIcon.faSearch} /> Search Item </a>
                    : null} 
                      {this.props?.permissions?.permissions?.includes("isc-item-add") &&  <a role="button" onClick={() => {this.setState({showItemAddModal : false},() => this.addItemModalInit())}} className="link-primary me-3"><tapIcon.FontAwesomeIcon icon={tapIcon.faPlus} /> Add Item</a>}
                        <a role="button" onClick={this.addNewItemRow} className="link-primary"><tapIcon.FontAwesomeIcon icon={tapIcon.faPlus} /> Add Row </a>
                    </div>}
                   
                </div>
            </div>
        </div>);
    }

    checkAllItemDemandList() {
        let indentItemForCheckbox      =   document.getElementsByClassName('demand_id_checkbox')
        if(indentItemForCheckbox && indentItemForCheckbox.length > 0) {
            for (let i = 0; i < indentItemForCheckbox.length; i++) {
                indentItemForCheckbox[i].checked = document.getElementById('all_check_demand').checked;
            }
        }
    }

    submitPickItemDemandFormSubmit = (e) => {
        e.preventDefault();

        let selectedDemandItems = [];
        let checkboxes = document.getElementsByClassName('demand_id_checkbox');

        // Collect checked items
        for (let i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked && !checkboxes[i].disabled) {
                const demandItemId = checkboxes[i].value;
                const selectedItem = this.state.allItemWiseDemandListing.find(
                    item => item.demand_data.demand_item_id == demandItemId
                );

                if (selectedItem && !this.state.allocationItemRows.some(row =>
                    row.demand_item_id === selectedItem.demand_data.demand_item_id
                )) {
                    selectedDemandItems.push(selectedItem);
                }
            }
        }

        if (selectedDemandItems.length === 0) {
            toast.error('Please select at least one Item', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        // Create new rows for selected items
        const newRows = selectedDemandItems.map(demandItem => {
            const data = demandItem.demand_data;
            const item = data.item_profile;

            return {
                item: item,
                qty: data.pending_qty || 0,
                rate: item.allocation_price || item.purchase_price || 0,
                demand_item_id: data.demand_item_id || '',
                demand_pending_qty: data.pending_qty || 0,
                demand_transaction_id: data.transaction_id || '',
                remark: '',
                stock_id: null,
                stock_qty: 0,
                free_qty: 0,
                current_stocks: [],
                selected_stock: null,
                stock_loading: item.category === 'goods',
                allApiCallsCompleted: item.category !== 'goods'
            };
        });

        // Add to existing rows
        const existingRowsWithItems = this.state.allocationItemRows.filter(row => row.item);
        const updatedRows = [...existingRowsWithItems, ...newRows];

        this.setState({
            allocationItemRows: updatedRows,
            buttonDisabled: true
        }, () => {
            // Fetch stock for goods items
            selectedDemandItems.forEach((demandItem, index) => {
                const data = demandItem.demand_data;
                const item = data.item_profile;
                const rowIndex = existingRowsWithItems.length + index;

                if (item.category === 'goods') {
                    this.getItemInventoryLevel(item.id, rowIndex, null, item.category);
                }
            });
        });

        this.pickItemDemandModal.hide();
        toast.success(`${selectedDemandItems.length} items added from demand`,
            { position: toast.POSITION.TOP_RIGHT });
    }


    handleTickeSearch = (selectedOption) => {
        // Handle ticket clearing case
        if (!selectedOption || !selectedOption.value) {
            // Reset all ticket-related fields
            this.setState({
                allocationForm: {
                    ...this.state.allocationForm,
                    ticket_id: '',
                    sub_assembly_id: '',
                    workstation_id: '',
                    employee_id: '',
                    asset_id: '',
                    allocation_for: this.state.allocationForm.allocation_for || '' // Keep existing or reset to empty
                },
                forData: {
                    ...this.state.forData,
                    chageWarehouse: !this.state.forData.chageWarehouse,
                    ticketSelected: false,
                    warehouseSites: [],
                    editData: {
                        ...this.state.forData.editData,
                        type: this.state.allocationForm.allocation_for || '',
                        sub_assembly_id: '',
                        selected_subassembly: null,
                        workstation_id: '',
                        selected_workstation: null,
                        employee_id: '',
                        selected_employee: null,
                        asset_id: '',
                        selected_asset: null,
                    }
                },
                allWarehouses: this.props.all_warehouses && this.props.all_warehouses.length > 0
                    ? this.props.all_warehouses.map((s) => {
                        return { value: s.id, label: `${s.name} (${s.code})`, site_id: s.site_ids };
                    })
                    : [],
                searchSubassembly: null,
                searchedEmployee: null,
                selectedAsset: null,
                searchedWorkstation: null,
                selectedTicket: null,
                ticketFromAllocation: false
            });
            return;
        }
        console.log(selectedOption,'jjj')

        // Existing logic when ticket is selected
        let warehouseList = this.state.allWarehouses;
        if (selectedOption && selectedOption.data) {
            warehouseList = warehouseList.filter(st => st.site_id.includes(selectedOption.data.site.id));
        } else {
            warehouseList = this.props.all_warehouses && this.props.all_warehouses.length > 0
                ? this.props.all_warehouses.map((s) => {
                    return { value: s.id, label: `${s.name} (${s.code})`, site_id: s.site_ids };
                })
                : [];
        }

        
        this.setState({
            allocationForm: {
                ...this.state.allocationForm,
                ticket_id: selectedOption && selectedOption.value ? selectedOption.value : '',
                sub_assembly_id: selectedOption && selectedOption.data && selectedOption.data.subAssembly
                    ? selectedOption.data.subAssembly.enc_id
                    : this.state.allocationForm.sub_assembly_id,
                workstation_id: selectedOption && selectedOption.data && selectedOption.data.workStation
                    ? selectedOption.data.workStation.id
                    : this.state.allocationForm.workstation_id,
                employee_id: selectedOption && selectedOption.data && selectedOption.data.employee
                    ? selectedOption.data.employee.enc_id
                    : this.state.allocationForm.employee_id,
                asset_id: selectedOption && selectedOption.asset
                    ? selectedOption.asset.asset_id
                    : this.state.allocationForm.asset_id,
                allocation_for: selectedOption && selectedOption.data && selectedOption.data.ticket_for
                    ? selectedOption.data.ticket_for
                    : this.state.allocationForm.allocation_for
            },
            forData: {
                ...this.state.forData,
                chageWarehouse: !this.state.forData.chageWarehouse,
                ticketSelected: selectedOption && selectedOption.data.ticket_for  ? true : false,
                warehouseSites: selectedOption && selectedOption.data.ticket_for ? [{...selectedOption.data.site.id}] : [],
                editData: {
                    ...this.state.forData.editData,
                    type: selectedOption && selectedOption.data && selectedOption.data.ticket_for
                        ? selectedOption.data.ticket_for
                        : this.state.allocationForm.demand_for,
                    sub_assembly_id: selectedOption && selectedOption.data && selectedOption.data.subAssembly
                        ? selectedOption.data.subAssembly.enc_id
                        : this.state.allocationForm.sub_assembly_id,
                    workstation_id: selectedOption && selectedOption.data && selectedOption.data.workStation
                        ? selectedOption.data.workStation.id
                        : this.state.allocationForm.workstation_id,
                    employee_id: selectedOption && selectedOption.data && selectedOption.data.employee
                        ? selectedOption.data.employee.enc_id
                        : this.state.allocationForm.employee_id,
                    asset_id: selectedOption && selectedOption.asset
                        ? selectedOption.asset.asset_id
                        : this.state.allocationForm.asset_id,
                    selected_subassembly: selectedOption && selectedOption.data && selectedOption.data.subAssembly
                        ? {
                            subAssembly: selectedOption.data.subAssembly,
                            value: selectedOption.data.subAssembly.enc_id,
                            label: `${selectedOption.data.subAssembly.name}`,
                            display_label: `${selectedOption.data.subAssembly.name}`
                        }
                        : null,
                    selected_employee: selectedOption && selectedOption.data.employee
                        ? {
                            value: selectedOption.data.employee.enc_id,
                            label: `${selectedOption.data.employee.name}`
                        }
                        : null,
                    selected_asset: selectedOption && selectedOption.asset
                        ? {
                            ...selectedOption.asset,
                            label: `${selectedOption.asset.name} (${selectedOption.asset.asset_code})`
                        }
                        : null,
                    selected_workstation: selectedOption && selectedOption.data.workStation
                        ? {
                            value: selectedOption.data.workStation.id,
                            label: `${selectedOption.data.workStation.name}`
                        }
                        : null,
                }
            },
            allWarehouses: warehouseList,
            searchSubassembly: selectedOption && selectedOption.data && selectedOption.data.subAssembly
                ? {
                    subAssembly: selectedOption.data.subAssembly,
                    value: selectedOption.data.subAssembly.enc_id,
                    label: `${selectedOption.data.subAssembly.name}`,
                    display_label: `${selectedOption.data.subAssembly.name}`
                }
                : null,
            searchedEmployee: selectedOption && selectedOption.data.employee
                ? {
                    value: selectedOption.data.employee.enc_id,
                    label: `${selectedOption.data.employee.name}`
                }
                : null,
            selectedAsset: selectedOption && selectedOption.asset
                ? {
                    ...selectedOption.asset,
                    label: `${selectedOption.asset.name} (${selectedOption.asset.asset_code})`
                }
                : null,
            searchedWorkstation: selectedOption && selectedOption.data.workStation
                ? {
                    value: selectedOption.data.workStation.id,
                    label: `${selectedOption.data.workStation.workstation_name}`
                }
                : null,
            selectedTicket: selectedOption
                ? {
                    ...selectedOption.asset,
                    asset_id: selectedOption && selectedOption.asset ? selectedOption.asset.asset_id : '',
                    label: selectedOption.display_label,
                    data: selectedOption && selectedOption.data ? selectedOption.data : null
                }
                : null,
        });
    }


    pickDemandItemModalJsx              =   ()  =>  {
        return (
            <div className="modal fade" id="pickItemDemandModal" tabIndex="-1">
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="vendorDetailsModalLabel">Pick Item from Approved Demand </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                       
                            <div className="modal-body">
                                <table className="table table-hover table-borderless my-2">
                                    <tbody>
                                        <tr>
                                            <td style={{ width: "25%" }}>Warehouse</td>
                                            <td>{this.state?.warehouseDetail?.name}</td>
                                        </tr>
                                       

                                    </tbody>
                                </table>
                                <form onSubmit={this.submitPickItemDemandFormSubmit} className="bg-white"  id="pickDemandForm"  method="post" encType="multipart/form-data">
                                <table className="table table-hover table-bordered table-responsive table-sm bg-white mt-3">
                                    <thead className="table-secondary">
                                        <tr  className="text-end">
                                            <th scope="col" style={{ width: "5%" }} className="text-center">
                                            <input type="checkbox" onChange={this.checkAllItemDemandList} id="all_check_demand" />
                                                </th>
                                            <th scope="col" className="text-start" style={{ width: "25%" }}>Item Name</th>
                                            <th scope="col" className="text-start" style={{ width: "25%" }}>Item Code</th>
                                            <th scope="col" style={{ width: "15%" }}>Demand ID</th>
                                            <th scope="col" style={{ width: "15%" }}>Pending Qty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                       
                                        {this.state.demand_loading ? <tr colSpan={5}><td colSpan={5} className='text-center'><Loader/></td></tr> : this.state.allItemWiseDemandListing && this.state.allItemWiseDemandListing.length > 0 ? this.state.allItemWiseDemandListing.filter(dl => dl.value == this.state.allocationForm.demand_transaction_id).map((dl,k) => {
                                            let data = dl.demand_data ? dl.demand_data : null;
                                            let item = data && data.item_profile ? data.item_profile : null;
                                            return(<tr className="text-end">
                                                 <td className='text-center'>
                                                            <input
                                                                type='checkbox'
                                                                name="demand_id_checkbox"
                                                                className="demand_id_checkbox"
                                                                value={data.demand_item_id}
                                                                data-itemId={data.item_id}
                                                                data-qty={data?.new_qty}
                                                                disabled={this.state.allocationItemRows.find(element => {
                                                                    if (element?.demand_item_id == data.demand_item_id && element?.item?.id == data.item_id) {
                                                                        return true;
                                                                    } else {
                                                                        return false;
                                                                    }
                                                                })}
                                                            />
                                                        </td>
                                                <td className="text-start">{item && item.name ? item.name : ''}</td>
                                                <td className="text-start">{item && item.item_code ? item.item_code : ''}</td>
                                                <td className="text-center">{data && data.transaction_id ? data.transaction_id : ''}</td>
                                                <td>{data && data.pending_qty ? data.pending_qty : ''}</td>

                                            </tr>)
                                        }) : <tr colSpan={5}><td colSpan={5} className='text-center'>No Record</td></tr>}
                                        
                                    </tbody>
                                </table>
                                 </form>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" disabled={this.state.savePickItemSubmitting} className="btn btn-primary" form="pickDemandForm">Add to Allocation {this.state.savePickItemSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}</button>
                            </div>
                       
                    </div>
                </div>
            </div>
        );
    }

   
    saveallocationFormJsx              =   ()  =>  {
        let sub_total_amount                =   0;
        this.state.allocationItemRows.forEach((item,key) => {
            if(item && item.item) {
                    sub_total_amount     +=  item.rate * item.qty;
            }
        });
        
        let transactionDate = this.state.allocationForm && this.state.allocationForm.transaction_date ?  moment(this.state.allocationForm.transaction_date).format('YYYY-MM-DD 00:00:00') : null;
        
        return (<form className="bg-white p-3" onSubmit={this.allocationFormSubmitHandler}>
            
            <div className="row align-items-center my-3">
                <div className="col-sm-3">
                    <label htmlFor="site_id" className="form-label require">Date of Transaction</label>
                </div>
                <div className="col-sm-4 add_calender_section">
                    <DatePicker
                        selected={
                            this.state.allocationForm.transaction_date
                                ? moment(this.state.allocationForm.transaction_date, 'YYYY-MM-DD').toDate()
                                : false
                        }
                        name="transaction_date"
                        onChange={(value, event) => this.formDateHandler('transaction_date', value, 'allocationForm')}
                        maxDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                        dateFormat="dd-MMM-yyyy"
                        className={"form-control"}
                        showMonthDropdown
                        showYearDropdown
                        autoComplete="off"
                        scrollMonthYearDropdown
                        required={true}
                        disabled={this.state.isc_prevent_back_day_voucher == 'Y' ? true : false}
                        placeholderText={`Please Enter Date of Transaction`}
                    />
                    <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="requisition_date" className="add_calender-icon" />
                </div>
            </div>
            <div className="row align-items-center my-3">
                <div className="col-sm-3">
                    <label htmlFor="warehouse_id" className="form-label require">Warehouse</label>
                </div>
                <div className="col-sm-7">
                    <TapSelect
                        changeEvent={(selectedOption) => {
                            this.tapSelectChange(selectedOption, 'allocationForm', 'warehouse_id', () => {
                                this.onWarehouseChange(selectedOption);
                            });
                        }}
                        options={this.state.allWarehouses}
                        isSearchable={true}
                        required={true}
                        //search_site_id={this.state.ticketSelectedSite ? this.state.ticketSelectedSite : ""}
                        isDisabled={this.state.allocationDetail ? true : false}
                        value={this.state.allWarehouses.find(m => m.value == this.state.allocationForm.warehouse_id)}
                        placeholder="Please Select Warehouse"
                    />
                </div>
            </div>
            {this.state.warehouseDetail
                ? <div className="row align-items-center mt1">
                    <div className="offset-3 col-sm-8"><WarehouseAddress warehouseDetail={this.state.warehouseDetail} /></div>
                </div>
                : (this.state.warehouseDetailLoading ? <Loader /> : null)
            }

            <div className="row my-3">
                <GeneralSelectFor forData={this.state.forData} afterSelectForData={this.afterSelectForData}/>
            </div>
            
            <div className="row align-items-center my-3">
                <div className="col-sm-3">
                    <label htmlFor="warehouse_id" className="form-label require">Status</label>
                </div>
                <div className="col-sm-4">
                    <TapSelect
                        changeEvent={(selectedOption) => {
                            this.tapSelectChange(selectedOption, 'allocationForm', 'status')
                        }}
                        options={this.state.allStatus}
                        isSearchable={true}
                        required={true}
                        value={this.state.allStatus.find(m => m.value == this.state.allocationForm.status)}
                        placeholder="Please Select Status"
                        isDisabled={this.state.allocationDetail ? true : false}
                    />
                </div>
            </div>
            {this.state.ticket_allocation == 'Y' &&
                <div className="row align-items-center my-3">
                    <div className="col-sm-3">
                        <label htmlFor="warehouse_id" className="form-label">Ticket</label>
                    </div>
                    <div className="col-sm-4">
                <InputTicketSearch
                        changeEvent={(selectedOption) => {
                            this.handleTickeSearch(selectedOption);
                        }}
                        placeholder="Search Ticket"
                        search_site_id={this.state.warehouseSites.map(st => st.id)}
                        search_asset_id={this.state.allocationForm.asset_id ? this.state.allocationForm.asset_id : null }
                        search_employee_id={this.state.allocationForm.employee_id ? this.state.allocationForm.employee_id : null}
                        search_workstation={this.state.allocationForm.workstation_id ? this.state.allocationForm.workstation_id : null}
                        search_sub_assembly={this.state.allocationForm.sub_assembly_id ? this.state.allocationForm.sub_assembly_id : null}
                       // disabled={(!this.state.allocationForm.warehouse_id)}
                        value={this.state.selectedTicket ? { ...this.state.selectedTicket } : null}
                        search_exclude_ticket_status={[0,26,10]}
                    />
                 
                </div>
            </div>}
            <div className="row align-items-center my-3">
                <div className="col-sm-3">
                    <label htmlFor="voucher_number" className="form-label">Voucher Number & Date</label>
                </div>
                <div className="col-sm-4">
                    <input
                        name="voucher_number"
                        type="text"
                        className="form-control"
                        autoComplete="off"
                        value={this.state.allocationForm.voucher_number}
                        onChange={(e) => this.formInputHandler(e, 'allocationForm')}
                        placeholder="Enter Voucher Number"
                    />
                </div>
                <div className="col-sm-4 add_calender_section">
                    <DatePicker
                        selected={this.state.allocationForm.voucher_date ? moment(this.state.allocationForm.voucher_date).toDate() : false}
                        name="voucher_date"
                        onChange={(value, event) => this.formDateHandler('voucher_date', value, 'allocationForm')}
                        // maxDate={moment().toDate()}
                        dateFormat="dd-MMM-yyyy"
                        className={"form-control"}
                        showMonthDropdown
                        showYearDropdown
                        autoComplete="off"
                        scrollMonthYearDropdown
                        placeholderText={`Enter Voucher Date`}
                    />
                    <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="allocation_date" className="add_calender-icon" />
                </div>
            </div>
            {/* <div className="row align-items-center my-3 ">
                <div className="col-sm-3">
                    <label htmlFor="site_id" className="form-label">Item Demand <br /></label>
                </div>
                <div className="col-sm-7">
                    <button
                        type="button"
                        disabled={this.state.allocationForm.warehouse_id && (this.state.allocationForm.asset_id || this.state.allocationForm.sub_assembly_id || this.state.allocationForm.employee_id || this.state.allocationForm.workstation_id) ? false : true}
                        className="btn btn-link text-decoration-none"
                       onClick={() => this.pickItemDemandModalInit()}
                    ><tapIcon.FontAwesomeIcon icon={tapIcon.faPlus} />  Pick Item from Approved Item Demand</button>
                </div>


            </div> */}
             <div className="row align-items-center my-3">
                    <div className="col-sm-3">
                        <label htmlFor="site_id" className="form-label ">Item Demand</label>
                    </div>
                {this.state.demand_listing_loading ? <div className='text-center col-sm-8'><Loader /></div>
                    : <Ax>
                        <div className="col-sm-4">
                            <TapSelect
                                changeEvent={(selectedOption) => {
                                    this.onDemandChange(selectedOption)
                                }}
                                options={this.state.allDemandListing}
                                isSearchable={true}
                                isClearable={true}
                                required={true}
                                 isDisabled={this.state.allocationDetail ? true : false}
                                value={this.state.allDemandListing.find(s => s.value == this.state.allocationForm.demand_transaction_id)}
                                placeholder="Select Item Demand"
                            />
                        </div>
                        <div className="col-sm-4">
                            <button
                                type="button"
                                disabled={this.state.allocationForm.demand_transaction_id ? false : true}
                                className="btn btn-link text-decoration-none"
                                onClick={() => this.pickItemDemandModalInit()}
                            ><tapIcon.FontAwesomeIcon icon={tapIcon.faPlus} />  Pick Item from Approved Item Demand</button>
                        </div>
                    </Ax>
                }
            </div>

            {this.allocationItemsJsx()}
            <div className="row align-items-center my-3">
                <div className="col-sm-6">
                    <label htmlFor="notes" className="form-label">Notes</label>
                    <textarea
                        name="notes"
                        value={this.state.allocationForm.notes}
                        onChange={(e) => this.formInputHandler(e, 'allocationForm')}
                        className="form-control"
                        style={{ height: "100px" }}
                    />
                </div>
                <div className="col-sm-6">
                    <table className="table table-borderless">
                        <tbody>
                            <tr className="subtotal_bg_color"><th>Sub Total</th><td className="text-end">{(sub_total_amount).toFixed(2)}</td></tr>
                            <tr className="subtotal_bg_color pt-2">
                                <th>Adjustment</th>
                                <td>
                                    <input
                                        name="adjustment_amount"
                                        type="number"
                                        className="form-control text-end"
                                        autoComplete="off"
                                        value={this.state.allocationForm.adjustment_amount}
                                        onChange={(e) => this.formInputHandler(e, 'allocationForm')}
                                        placeholder="Adjustment Amount"
                                    />
                                </td>
                            </tr>
                            <tr className="subtotal_bg_color">
                                <th>Final Total</th>
                                <td className="text-end">
                                    {this.state.allocationForm.adjustment_amount
                                        ? (sub_total_amount + parseFloat(this.state.allocationForm.adjustment_amount)).toFixed(2)
                                        : (sub_total_amount).toFixed(2)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            
           {!this.state.buttonDisabled && <div className="col-12 text-end fixed_footer">
                <button type="button" disabled={this.state.saveFormSubmitting || this.state.buttonDisabled} onClick={this.closeEvent} className="btn btn-secondary ms-2">Cancel</button>
                {!this.state.allocationDetail || (this.state.allocationDetail && this.state.allocationDetail.status == 0)
                    ? <button type="button" disabled={this.state.saveFormSubmitting || this.state.buttonDisabled} className="btn btn-secondary ms-2" onClick={(e) => { this.allocationFormSubmitHandler(e, 1); }}>
                        Save as a Draft {this.state.saveFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                    </button>
                    : null
                }
                <button type="button" disabled={this.state.saveFormSubmitting || this.state.buttonDisabled} className="btn btn-primary ms-2" onClick={(e) => { this.allocationFormSubmitHandler(e, this.state.allocationForm.status); }}>
                    Save  {this.state.saveFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                </button>

            </div>}
        </form>);
    }
    
    render                              =   ()  =>  {
        return (<ApplicationLayout>
        <Helmet><title>Add Allocation</title></Helmet>
            {this.pageTitlejsx()}
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-12 pl4">
                    { this.state.form_loading 
                        ? <Loader/>
                        : this.saveallocationFormJsx()
                    }
                    </div>
                </div>
            </div>
            {/* {this.allocationHistoryModalJsx()} */}
            {this.pickDemandItemModalJsx()}
            {this.state.showItemAddModal && <AddItemModal parentProps={this.props} ref={this.addItemModalRef} />}
            {this.state.showItemEditModal && <ItemEditModal parentProps={this.props} ref={this.editItemModalRef} afterSubmitItem={this.submitEditItem} />}
            <ItemDetailsModal ref={this.itemDetailsRef} />  
            <allocationHistoryModal ref={this.allocationHistoryRef}/>
            {this.state.showItemSearchModal && <ItemSearchModal ref={this.itemSearchRef}
                            afterSelectingItems={(selectedItems) => {
                                this.addItemsfromSearch(selectedItems);
                            }}
                        />}
        </ApplicationLayout>);
    }
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        isc_configuration       :   state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
        isc_setting             :   state.app && state.app.isc_setting ? state.app.isc_setting : null,
        iam_group_sites         :   state.app && state.app.user_sites ? state.app.group_sites : [],
        permissions            :   state.app.acl_info,
        all_warehouses          :   state.app && state.app.warehouses ? state.app.warehouses : [],
    };
};

export default connect(mapStateToProps)(AllocationAdd);